<script setup lang="ts">
import type { Component } from 'vue';

import AcornIcon from '@/components/base/assets/AcornIcon.vue';
import ChocolateBarIcon from '@/components/base/assets/ChocolateBarIcon.vue';
import CompanyIcon from '@/components/base/assets/CompanyIcon.vue';
import CookieIcon from '@/components/base/assets/CookieIcon.vue';
import FruitIcon from '@/components/base/assets/FruitIcon.vue';
import GiftBoxIcon from '@/components/base/assets/GiftBoxIcon.vue';
import HealthyIcon from '@/components/base/assets/HealthyIcon.vue';
import KidsBackpackIcon from '@/components/base/assets/KidsBackpackIcon.vue';
import OfficeIcon from '@/components/base/assets/OfficeIcon.vue';
import OrangeSliceIcon from '@/components/base/assets/OrangeSliceIcon.vue';
import PartnerIcon from '@/components/base/assets/PartnerIcon.vue';
import PeopleIcon from '@/components/base/assets/PeopleIcon.vue';
import PepperShakerIcon from '@/components/base/assets/PepperShakerIcon.vue';
import PersonIcon from '@/components/base/assets/PersonIcon.vue';
import PretzelIcon from '@/components/base/assets/PretzelIcon.vue';
import ShippingTruckIcon from '@/components/base/assets/ShippingTruckIcon.vue';
import ShopIcon from '@/components/base/assets/ShopIcon.vue';
import TwinkleIcon from '@/components/base/assets/TwinkleIcon.vue';
import { QuizAnswer } from '@/data/quiz/onsiteOffer';

defineProps<{
  quizAnswerId: string;
}>();

const iconMap: Record<QuizAnswer['id'], Component> = {
  'a-friend': GiftBoxIcon,
  'another-type-of-business': CompanyIcon,
  'bold-peppery': PepperShakerIcon,
  'bored-of-my-usual-snacks': TwinkleIcon,
  'chocolaty-rich': ChocolateBarIcon,
  convenience: ShippingTruckIcon,
  'crunchy-nutty': AcornIcon,
  'fruity-zesty': FruitIcon,
  gift: GiftBoxIcon,
  gifts: GiftBoxIcon,
  'health-wholesome': HealthyIcon,
  'healthier-snack-options': HealthyIcon,
  'healthy-lifestyle': HealthyIcon,
  'high-quality-premium-snacks': TwinkleIcon,
  'something-indulgent': CookieIcon,
  'indulgent-snacks': CookieIcon,
  'just-me': PersonIcon,
  'me-and-my-partner': PartnerIcon,
  'my-family-including-kids': PeopleIcon,
  'my-office-coworkers': OfficeIcon,
  'party-or-event': CompanyIcon,
  'party-planning': CompanyIcon,
  'savory-salty': PretzelIcon,
  'sweet-crunchy': CookieIcon,
  'sweet-gummy': OrangeSliceIcon,
  'unique-snacks': TwinkleIcon,
  'wide-selection': ShopIcon,
  'work-school': KidsBackpackIcon,
  'work-or-school': KidsBackpackIcon,
};
</script>

<template>
  <component :is="iconMap[quizAnswerId]" />
</template>
